import axios from 'axios';

// Get backend URL from environment
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Statistics API
export const statisticsAPI = {
  get: async () => {
    try {
      const response = await apiClient.get('/statistics/');
      return response.data;
    } catch (error) {
      console.error('Error fetching statistics:', error);
      throw error;
    }
  }
};

// Testimonials API
export const testimonialsAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await apiClient.get('/testimonials/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      throw error;
    }
  }
};

// Settings API
export const settingsAPI = {
  getContactInfo: async () => {
    try {
      const response = await apiClient.get('/settings/contact');
      return response.data;
    } catch (error) {
      console.error('Error fetching contact info:', error);
      throw error;
    }
  }
};

// Events API
export const eventsAPI = {
  getUpcoming: async (params = {}) => {
    try {
      const response = await apiClient.get('/events/upcoming', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching upcoming events:', error);
      throw error;
    }
  }
};

// Newsletter API
export const newsletterAPI = {
  subscribe: async (data) => {
    try {
      const response = await apiClient.post('/newsletter/subscribe', data);
      return response.data;
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      throw error;
    }
  },
  
  getSubscriberCount: async () => {
    try {
      const response = await apiClient.get('/newsletter/subscribers/count');
      return response.data;
    } catch (error) {
      console.error('Error fetching subscriber count:', error);
      throw error;
    }
  }
};

// Applications API
export const applicationsAPI = {
  submit: async (data) => {
    try {
      const response = await apiClient.post('/applications/', data);
      return response.data;
    } catch (error) {
      console.error('Error submitting application:', error);
      throw error;
    }
  }
};

// Auth API
export const authAPI = {
  register: async (userData) => {
    try {
      const response = await apiClient.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      console.error('Error during registration:', error);
      throw error;
    }
  },
  
  login: async (credentials) => {
    try {
      const response = await apiClient.post('/auth/login', credentials);
      return response.data;
    } catch (error) {
      console.error('Error during login:', error);
      throw error;
    }
  },
  
  getCurrentUser: async (token) => {
    try {
      const response = await apiClient.get('/auth/me', {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching current user:', error);
      throw error;
    }
  }
};

// Helper function to handle API errors
export const handleAPIError = (error) => {
  if (error.response) {
    // Server responded with error status
    return {
      message: error.response.data.detail || 'Server error occurred',
      status: error.response.status
    };
  } else if (error.request) {
    // Request was made but no response received
    return {
      message: 'Network error - please check your connection',
      status: null
    };
  } else {
    // Something else happened
    return {
      message: error.message || 'An unexpected error occurred',
      status: null
    };
  }
};